/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type ForReviewQueueRouteLocal = {
    readonly moderationQueueSort: COMMENT_SORT | null;
    readonly " $refType": "ForReviewQueueRouteLocal";
};
export type ForReviewQueueRouteLocal$data = ForReviewQueueRouteLocal;
export type ForReviewQueueRouteLocal$key = {
    readonly " $data"?: ForReviewQueueRouteLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"ForReviewQueueRouteLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ForReviewQueueRouteLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moderationQueueSort",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'e57ff695428bec3f33436043d4909482';
export default node;
